module.exports = __webpack_public_path__ + "static/img/mini4.27c770d5.png";